import { getPanelCornerPoints } from '../../panels/helpers';
import { nearestSixteenth } from '../../../helpers';
import { Obstruction } from '../obstruction.class';
import { Size } from '../../../types';

/**
 * Calculates obstruction baseSize bsaed on obstruction type. Base size represents the outside dimensions and do not include countertop overhangs
 * @param obstruction Island to calculate the base size for
 * @returns Size
 */
export const getIslandSizeCfn = (obstruction: Obstruction): Size => {
	const { panel } = obstruction;
	let islandSize: Size | null = null;

	let xMin = 0;
	let xMax = 0;
	let yMin = 0;
	let yMax = 0;
	let zMin = 0;
	let zMax = 0;

	const cp = getPanelCornerPoints(panel, { inside: false, translate: true, rotate: true, nearestSixteenth: false, lock: false }, new Set());
	// const cp = p.getCornerPoints(false, { translate: true, lock: false }, new Set());
	xMin = Math.min(xMin, cp.corners[0].x);
	xMax = Math.max(xMax, cp.corners[1].x);
	yMin = Math.min(yMin, cp.corners[0].y);
	yMax = Math.max(yMax, cp.corners[1].y);
	zMin = Math.min(zMin, cp.corners[0].z);
	zMax = Math.max(zMax, cp.corners[1].z);

	islandSize = {
		width: nearestSixteenth(xMax - xMin),
		height: nearestSixteenth(yMax - yMin),
		depth: nearestSixteenth(zMax - zMin)
	};

	return islandSize;
};
